import {Box, Colors, Text} from "@bounce/shared/ui";
import HtmlFrame from "./HtmlFrame";

const EMAIL_PREVIEW_SENDER_NAME = "Bounce";
const EMAIL_PREVIEW_SENDER_EMAIL = "noreply@bounceai.com";
const EMAIL_PREVIEW_AVATAR_COLOR = "#1A73E8";

type EmailViewProps = {
  subject: string;
  preHeader: string;
  body: string;
  compact: boolean;
};

const EmailView = ({subject, preHeader, body, compact}: EmailViewProps) => {
  const avatarSize = compact ? 28 : 36;
  const subjectSize = compact ? 16 : 18;
  const trimmedPreHeader = preHeader.trim();
  return (
    <Box sx={{display: "flex", flexDirection: "column", height: "100%", backgroundColor: Colors.bw.white}}>
      <Box
        sx={{
          padding: compact ? "12px 14px" : "16px 20px",
          borderBottom: `1px solid ${Colors.grey._200}`,
          display: "flex",
          flexDirection: "column",
          gap: compact ? 0.75 : 1,
        }}
      >
        <Text
          size={subjectSize}
          sx={{
            color: Colors.grey._900,
            fontWeight: 600,
            wordBreak: "break-word",
          }}
        >
          {subject || "(no subject)"}
        </Text>
        <Box sx={{display: "flex", alignItems: "center", gap: compact ? 1 : 1.5}}>
          <Box
            sx={{
              width: avatarSize,
              height: avatarSize,
              borderRadius: "50%",
              backgroundColor: EMAIL_PREVIEW_AVATAR_COLOR,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Text size={compact ? 12 : 14} sx={{color: Colors.bw.white, fontWeight: 600}}>
              {EMAIL_PREVIEW_SENDER_NAME.charAt(0).toUpperCase()}
            </Text>
          </Box>
          <Box sx={{flex: 1, minWidth: 0, display: "flex", flexDirection: "column"}}>
            <Box sx={{display: "flex", justifyContent: "space-between", gap: 1, alignItems: "baseline"}}>
              <Text
                size={compact ? 12 : 13}
                sx={{
                  color: Colors.grey._900,
                  fontWeight: 600,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {EMAIL_PREVIEW_SENDER_NAME} {"<"}
                {EMAIL_PREVIEW_SENDER_EMAIL}
                {">"}
              </Text>
              <Text size={compact ? 11 : 12} sx={{color: Colors.grey._600, flexShrink: 0}}>
                Now
              </Text>
            </Box>
            <Text size={compact ? 11 : 12} sx={{color: Colors.grey._600}}>
              to me
            </Text>
          </Box>
        </Box>
        {trimmedPreHeader && (
          <Text size={compact ? 11 : 12} sx={{color: Colors.grey._600, fontStyle: "italic"}}>
            {trimmedPreHeader}
          </Text>
        )}
      </Box>
      <HtmlFrame html={body} title="Email preview" sx={{flex: 1}} />
    </Box>
  );
};

export default EmailView;
